import styled from "styled-components";
import { BUTTON_SIZES, RAButtonPrimary, RAButtonSecondary, RATypography } from "@/components/customs";
import { Row, Col, Modal, Grid } from "antd";
import { IconCloseSvg } from "@/components/svgs";
const { useBreakpoint } = Grid;

export function ModalConfirmAction({ visible = false, onClose, title = "", note = "", onConfirm }) {
	const screens = useBreakpoint();
	return (
		<Modal
			centered
			closeIcon={<IconCloseSvg />}
			open={visible}
			onCancel={() => onClose()}
			footer={null}
			width="550px"
		>
			<ContainerAddContact>
				<Row>
					<Col md={24}>
						<WrapperContent>
							<RATypography variant="h3">{title}</RATypography>
						</WrapperContent>
						{!!note && (
							<RATypography variant="body3" top="12px" color="#595959">
								{note}
							</RATypography>
						)}
					</Col>
				</Row>
				<Row justify="center" align="middle" style={{ marginTop: "30px" }} gutter={[20, 20]}>
					<Col>
						<RAButtonSecondary
							data-testid="ConfirmAction_cancelBtn"
							title="CANCEL"
							onClick={() => onClose()}
							width={screens.xs ? "140px" : "152px"}
							size={screens.xs ? BUTTON_SIZES.medium : BUTTON_SIZES.large}
						/>
					</Col>
					<Col>
						<RAButtonPrimary
							data-testid="ConfirmAction_confirmBtn"
							title="CONFIRM"
							onClick={() => onConfirm()}
							width={screens.xs ? "140px" : "152px"}
							size={screens.xs ? BUTTON_SIZES.medium : BUTTON_SIZES.large}
						/>
					</Col>
				</Row>
			</ContainerAddContact>
		</Modal>
	);
}

const ContainerAddContact = styled.div`
	width: "100%";
	padding: 30px;
	@media (max-width: 576px) {
		padding: 0;
	}
`;
const WrapperContent = styled.div`
	padding: 0px 20px;
	flex-direction: column;
	align-items: center;
	border-left: 2px solid #ffb11a;
`;
